<script>
import Drawer from "@/components/drawer";
import Swal from "sweetalert2";
import { required } from "vuelidate/lib/validators";

// Custom components
import PageHeader from "@/components/page-header";
import maintenanceRequest from "@/components/maintenanceRequest/index.vue";
import UserService from "@/helpers/APIService/user.service";
import errorHandler from "@/helpers/errorHandler";
import Middleware from "@/helpers/middlewares";
import { authComputed } from "@/state/helpers";
import appConfig from "@/app.config";

export default {
  page: {
    title: "Maintenance Request",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    PageHeader,
    Drawer,
    maintenanceRequest,
  },
  data() {
    return {
      title: "Maintenance Request Types",
      openNewRequestForm: false,
      isEdit: false,
      tableData: [],
      updateValueId: "",
      isDataLoading: false,
      updateDataId: "",
    };
  },
  computed: {
    ...authComputed,
    maintenanceRequestFormProps() {
      return { isEdit: this.isEdit, updateValueId: this.updateValueId };
    },
  },
  mounted() {
    this.getAllMaintenanceRequestData();
  },
  validations: {
    image: {
      required,
    },
  },
  methods: {
    getAllMaintenanceRequestData() {
      this.isDataLoading = true;
      const query = "";
      UserService.getAllMaintenceRequest(query).then((response) => {
        this.tableData = response;
        this.isDataLoading = false;
      });
    },
    newMaintenanceRequestForm() {
      if (this.openNewRequestForm === true) {
        this.isEdit = false;
        this.updateValueId = "";
      }
      this.openNewRequestForm = !this.openNewRequestForm;
    },
    maintenanceRequestAddedUpdated(data, isEdit) {
      if (isEdit) {
        this.tableData = this.tableData.map((item) => {
          if (item.id === data.id) {
            item = data;
          }
          return item;
        });
      } else {
        this.tableData.push(data);
      }
      this.newMaintenanceRequestForm();
    },
    saveAndAddNewMaintenanceRequest(data) {
      this.tableData.push(data);
      this.newMaintenanceRequestForm();
    },
    editMaintenanceRequest(id, index) {
      this.isEdit = true;
      this.updateValueId = id;
      this.newMaintenanceRequestForm();
    },
    deleteMaintenanceRequest(id, index) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#238dfa",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.value) {
          UserService.deleteMaintenceRequest(id)
            .then((response) => {
              this.tableData.splice(index, 1);
              Middleware.notification("Successfully deleted !!", "danger");
            })
            .catch((error) => {
              errorHandler(error);
            });
        }
      });
    },
    changeMaintenanceRequestStatus(data) {
      let maintenanceRequest = new FormData();
      maintenanceRequest.append("is_active", data.is_active);
      UserService.updateMaintenceRequest(data.id, maintenanceRequest).then(
        () => {
          Middleware.notification("Successfully changed !!", "success");
        },
        (error) => {
          errorHandler(error);
        }
      );
    },
  },
};
</script>

<template>
  <div>
    <PageHeader
      :title="title"
      :action="newMaintenanceRequestForm"
      text="Add New Request Type"
      :isButton="true"
    />

    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-12 mt-2">
                <div class="table-responsive mb-0" v-dragscroll>
                  <table
                    class="table table-hover mb-0"
                    ref="my-table"
                    infinite-scroll-disabled="busy"
                    infinite-scroll-distance="10"
                  >
                    <thead class="table-light">
                      <tr>
                        <th>Name</th>
                        <th>Icon</th>
                        <th>Status</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody v-if="isDataLoading">
                      <tr v-for="item in 10" :key="item">
                        <td class="placeholder-glow" v-for="no in 4" :key="no">
                          <span class="placeholder w-100 placeholder-lg"></span>
                        </td>
                      </tr>
                    </tbody>
                    <tbody v-else>
                      <tr v-for="(data, index) in tableData" :key="data.id">
                        <td @click="editMaintenanceRequest(data.id, index)">
                          <span class="text-dark">
                            {{ data.name }}
                          </span>
                        </td>
                        <td @click="editMaintenanceRequest(data.id, index)">
                          <div class="row">
                            <div class="col">
                              <i
                                class="me-2 fs-5 text-secondary"
                                :class="data.icon"
                              ></i>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div
                            class="form-check form-switch my-1"
                            slot="is_active"
                          >
                            <input
                              class="form-check-input"
                              type="checkbox"
                              v-model="data.is_active"
                              @change="
                                changeMaintenanceRequestStatus({
                                  id: data.id,
                                  is_active: data.is_active,
                                })
                              "
                            />
                          </div>
                        </td>
                        <td>
                          <div slot="actions" class="d-flex align-items-center">
                            <i
                              class="fas fa-pencil-alt mx-1 text-success"
                              v-b-popover.hover="'Edit up sell'"
                              @click="editMaintenanceRequest(data.id, index)"
                            ></i>
                            <i
                              class="mdi mdi-trash-can mx-1 fs-5 text-danger"
                              v-b-popover.hover="'Delete Up Sell'"
                              @click="deleteMaintenanceRequest(data.id, index)"
                            ></i>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                    <tbody v-if="!isDataLoading && tableData.length == 0">
                      <tr>
                        <td colspan="9" class="text-center">
                          <img
                            src="@/assets/images/empty.svg"
                            class="img-fluid"
                            alt=""
                          />
                          <p>
                            <span class="text-secondary">No Data Found</span>
                          </p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Drawer is for open up sell Add/Edit -->
    <Drawer
      @close="newMaintenanceRequestForm()"
      :align="'right'"
      :closeable="true"
      :maskClosable="true"
      :zIndex="1002"
    >
      <div v-if="openNewRequestForm">
        <maintenanceRequest
          :currentProps="maintenanceRequestFormProps"
          @submitted="maintenanceRequestAddedUpdated"
          @cancelSubmit="newMaintenanceRequestForm"
          @saveAndAddNew="saveAndAddNewMaintenanceRequest"
        />
      </div>
    </Drawer>
  </div>
</template>
